import { select } from '../../utils/dom';
import { scrollIt } from '../../utils/misc';

// The scrollIt function takes either an integer offset or a DOM element
// and the offset in this case depends on the variation of the header
// that is present and visible.
const offset = (() => {
  if (select('.SiteHeader--only-logo')) {
    return 0;
  } else if (select('.SiteHeader') && select('.SiteHeader').offsetHeight > 0) {
    return select('.SiteHeader');
  }
  return select('.SiteHeader--mobile');
})();

export default {
  /**
   * Methods
   */
  methods: {
    scrollUp() {
      Vue.nextTick(() => {
        scrollIt(
          this.$el,
          500,
          'easeOutQuad',
          offset,
        );
      });
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/mixins/scrollUp.js